/**
 * Component: Learn Cloud Template 
 * 
 */
'use strict';


export class LearnCloud 
{
  constructor()
  {
    this.selectors = {
      component:    $('.t-v4-learn-cloud'),
      search_input: $('.t-v4-learn-cloud--nav-search input[type="search"]'),
      nav:          $('.t-v4-learn-cloud--nav-container'),
      navMobile:    $('.t-v4-learn-cloud--nav-container--mobile'),
      keywords:     $('.t-v4-learn-cloud--nav-keywords'),
      decal:        $('.t-v4-learn-cloud--nav-decal'),
      decalResults: $('.t-v4-learn-cloud--nav-decal-results'),
      results:      $('.t-v4-learn-cloud--nav-results'),
    };

    this.search_term         = '';
    this.url            = '';
  }

  init()
  {
    this.search_term         = this.selectors.search_input.val();

    this.init_search();
    this.init_cancel();
    this.init_keyword();
    this.init_chips();
  } 

  init_search()
  {
    let _self = this;

    this.selectors.search_input.on( 'keyup input', function()
    {
      _self.search_term = $(this).val().trim();
     
      if ( _self.search_term != '' )
      {
        _self.selectors.search_input.parent().addClass('active');
        _self.selectors.nav.addClass('hidden');
        _self.selectors.navMobile.addClass('hidden');
        _self.selectors.keywords.show();
        _self.selectors.decal.hide();
        _self.selectors.decalResults.show();
        _self.selectors.results.show();

        _self.make_ajax_request();
      } 
      else
      {
        _self.selectors.search_input.parent().removeClass('active');
        _self.selectors.nav.removeClass('hidden');
        _self.selectors.navMobile.removeClass('hidden');
        _self.selectors.keywords.hide();
        _self.selectors.decal.show();
        _self.selectors.decalResults.hide();
        _self.selectors.results.hide();
      }
    });

  }

  init_cancel() {
    let _self = this;
    document.addEventListener('click', e => {
      if (e.target.matches('.t-v4-learn-cloud--nav-search-cancel')) {
        _self.selectors.search_input.val('');

        _self.search_term = ''; 
        _self.selectors.search_input.parent().removeClass('active');
        _self.selectors.nav.removeClass('hidden');
        _self.selectors.navMobile.removeClass('hidden');
        _self.selectors.keywords.hide();
        _self.selectors.decal.show();
        _self.selectors.decalResults.hide();
        _self.selectors.results.hide();
      }
    });
  }


  init_keyword() {
    let _self = this;
    document.addEventListener('click', e => {
      if (e.target.closest('[data-keyword-learn]') != null) {
        let keyword = e.target.closest('[data-keyword-learn]');
        _self.selectors.search_input.val(keyword.innerHTML);
        _self.search_term = keyword.innerHTML; 
        _self.make_ajax_request();
      }
    });
  }

  init_chips() {
    const observer = new IntersectionObserver( 
      ([e]) => e.target.classList.toggle("pinned", e.intersectionRatio < 1),
      { 
        rootMargin: '-81px 0px 0px 0px',
        threshold: [1] 
      }
    );
    let target = document.querySelector('#stickyAnchors');

    if (target != null) {
      observer.observe(target);
    }
  }

  /**
   * Make ajax request
   * 
   */
  make_ajax_request()
  {
    let _self = this;

    $.ajax({
      type:    'POST',
      url:     sysdigLocalizedObject.ajaxUrl,
      data:    {
        action:     'sysdig_v4_filter__learn_cloud',
        term:       this.search_term,
      },
      success: function( resp )
      {
        _self.selectors.results.html( resp );
      }
    });
  }
}

